export const streetTypes = [
    {
        "id_tipo_logradouro": 0,
        "sigla": "IND",
        "nome": "Indeterminado"
    },
    {
        "id_tipo_logradouro": 1,
        "sigla": "A",
        "nome": "Área"
    },
    {
        "id_tipo_logradouro": 2,
        "sigla": "AC",
        "nome": "Acesso"
    },
    {
        "id_tipo_logradouro": 3,
        "sigla": "ACA",
        "nome": "Acampamento"
    },
    {
        "id_tipo_logradouro": 4,
        "sigla": "ACL",
        "nome": "Acesso Local"
    },
    {
        "id_tipo_logradouro": 5,
        "sigla": "AD",
        "nome": "Adro"
    },
    {
        "id_tipo_logradouro": 6,
        "sigla": "AE",
        "nome": "Área Especial"
    },
    {
        "id_tipo_logradouro": 7,
        "sigla": "AER",
        "nome": "Aeroporto"
    },
    {
        "id_tipo_logradouro": 8,
        "sigla": "AL",
        "nome": "Alameda"
    },
    {
        "id_tipo_logradouro": 9,
        "sigla": "AMD",
        "nome": "Avenida Marginal Direita"
    },
    {
        "id_tipo_logradouro": 10,
        "sigla": "AME",
        "nome": "Avenida Marginal Esquerda"
    },
    {
        "id_tipo_logradouro": 11,
        "sigla": "AN",
        "nome": "Anel Viário"
    },
    {
        "id_tipo_logradouro": 12,
        "sigla": "ANT",
        "nome": "Antiga Estrada"
    },
    {
        "id_tipo_logradouro": 13,
        "sigla": "ART",
        "nome": "Artéria"
    },
    {
        "id_tipo_logradouro": 14,
        "sigla": "AT",
        "nome": "Alto"
    },
    {
        "id_tipo_logradouro": 15,
        "sigla": "ATL",
        "nome": "Atalho"
    },
    {
        "id_tipo_logradouro": 16,
        "sigla": "A V",
        "nome": "Área Verde"
    },
    {
        "id_tipo_logradouro": 17,
        "sigla": "AV",
        "nome": "Avenida"
    },
    {
        "id_tipo_logradouro": 18,
        "sigla": "AVC",
        "nome": "Avenida Contorno"
    },
    {
        "id_tipo_logradouro": 19,
        "sigla": "AVM",
        "nome": "Avenida Marginal"
    },
    {
        "id_tipo_logradouro": 20,
        "sigla": "AVV",
        "nome": "Avenida Velha"
    },
    {
        "id_tipo_logradouro": 21,
        "sigla": "BAL",
        "nome": "Balneário"
    },
    {
        "id_tipo_logradouro": 22,
        "sigla": "BC",
        "nome": "Beco"
    },
    {
        "id_tipo_logradouro": 23,
        "sigla": "BCO",
        "nome": "Buraco"
    },
    {
        "id_tipo_logradouro": 24,
        "sigla": "BEL",
        "nome": "Belvedere"
    },
    {
        "id_tipo_logradouro": 25,
        "sigla": "BL",
        "nome": "Bloco"
    },
    {
        "id_tipo_logradouro": 26,
        "sigla": "BLO",
        "nome": "Balão"
    },
    {
        "id_tipo_logradouro": 27,
        "sigla": "BLS",
        "nome": "Blocos"
    },
    {
        "id_tipo_logradouro": 28,
        "sigla": "BLV",
        "nome": "Bulevar"
    },
    {
        "id_tipo_logradouro": 29,
        "sigla": "BSQ",
        "nome": "Bosque"
    },
    {
        "id_tipo_logradouro": 30,
        "sigla": "BVD",
        "nome": "Boulevard"
    },
    {
        "id_tipo_logradouro": 31,
        "sigla": "BX",
        "nome": "Baixa"
    },
    {
        "id_tipo_logradouro": 32,
        "sigla": "C",
        "nome": "Cais"
    },
    {
        "id_tipo_logradouro": 33,
        "sigla": "CAL",
        "nome": "Calçada"
    },
    {
        "id_tipo_logradouro": 34,
        "sigla": "CAM",
        "nome": "Caminho"
    },
    {
        "id_tipo_logradouro": 35,
        "sigla": "CAN",
        "nome": "Canal"
    },
    {
        "id_tipo_logradouro": 36,
        "sigla": "CH",
        "nome": "Chácara"
    },
    {
        "id_tipo_logradouro": 37,
        "sigla": "CHA",
        "nome": "Chapadão"
    },
    {
        "id_tipo_logradouro": 38,
        "sigla": "CIC",
        "nome": "Ciclovia"
    },
    {
        "id_tipo_logradouro": 39,
        "sigla": "CIR",
        "nome": "Circular"
    },
    {
        "id_tipo_logradouro": 40,
        "sigla": "CJ",
        "nome": "Conjunto"
    },
    {
        "id_tipo_logradouro": 41,
        "sigla": "CJM",
        "nome": "Conjunto Mutirão"
    },
    {
        "id_tipo_logradouro": 42,
        "sigla": "CMP",
        "nome": "Complexo Viário"
    },
    {
        "id_tipo_logradouro": 43,
        "sigla": "COL",
        "nome": "Colônia"
    },
    {
        "id_tipo_logradouro": 44,
        "sigla": "COM",
        "nome": "Comunidade"
    },
    {
        "id_tipo_logradouro": 45,
        "sigla": "CON",
        "nome": "Condomínio"
    },
    {
        "id_tipo_logradouro": 46,
        "sigla": "COR",
        "nome": "Corredor"
    },
    {
        "id_tipo_logradouro": 47,
        "sigla": "CPO",
        "nome": "Campo"
    },
    {
        "id_tipo_logradouro": 48,
        "sigla": "CRG",
        "nome": "Córrego"
    },
    {
        "id_tipo_logradouro": 49,
        "sigla": "CTN",
        "nome": "Contorno"
    },
    {
        "id_tipo_logradouro": 50,
        "sigla": "DSC",
        "nome": "Descida"
    },
    {
        "id_tipo_logradouro": 51,
        "sigla": "DSV",
        "nome": "Desvio"
    },
    {
        "id_tipo_logradouro": 52,
        "sigla": "DT",
        "nome": "Distrito"
    },
    {
        "id_tipo_logradouro": 53,
        "sigla": "EB",
        "nome": "Entre Bloco"
    },
    {
        "id_tipo_logradouro": 54,
        "sigla": "EIM",
        "nome": "Estrada Intermunicipal"
    },
    {
        "id_tipo_logradouro": 55,
        "sigla": "ENS",
        "nome": "Enseada"
    },
    {
        "id_tipo_logradouro": 56,
        "sigla": "ENT",
        "nome": "Entrada Particular"
    },
    {
        "id_tipo_logradouro": 57,
        "sigla": "EQ",
        "nome": "Entre Quadra"
    },
    {
        "id_tipo_logradouro": 58,
        "sigla": "ESC",
        "nome": "Escada"
    },
    {
        "id_tipo_logradouro": 59,
        "sigla": "ESD",
        "nome": "Escadaria"
    },
    {
        "id_tipo_logradouro": 60,
        "sigla": "ESE",
        "nome": "Estrada Estadual"
    },
    {
        "id_tipo_logradouro": 61,
        "sigla": "ESI",
        "nome": "Estrada Vicinal"
    },
    {
        "id_tipo_logradouro": 62,
        "sigla": "ESL",
        "nome": "Estrada de Ligação"
    },
    {
        "id_tipo_logradouro": 63,
        "sigla": "ESM",
        "nome": "Estrada Municipal"
    },
    {
        "id_tipo_logradouro": 64,
        "sigla": "ESP",
        "nome": "Esplanada"
    },
    {
        "id_tipo_logradouro": 65,
        "sigla": "ESS",
        "nome": "Estrada de Servidão"
    },
    {
        "id_tipo_logradouro": 66,
        "sigla": "EST",
        "nome": "Estrada"
    },
    {
        "id_tipo_logradouro": 67,
        "sigla": "ESV",
        "nome": "Estrada Velha"
    },
    {
        "id_tipo_logradouro": 68,
        "sigla": "ETA",
        "nome": "Estrada Antiga"
    },
    {
        "id_tipo_logradouro": 69,
        "sigla": "ETC",
        "nome": "Estação"
    },
    {
        "id_tipo_logradouro": 70,
        "sigla": "ETD",
        "nome": "Estádio"
    },
    {
        "id_tipo_logradouro": 71,
        "sigla": "ETN",
        "nome": "Estância"
    },
    {
        "id_tipo_logradouro": 72,
        "sigla": "ETP",
        "nome": "Estrada Particular"
    },
    {
        "id_tipo_logradouro": 73,
        "sigla": "ETT",
        "nome": "Estacionamento"
    },
    {
        "id_tipo_logradouro": 74,
        "sigla": "EVA",
        "nome": "Evangélica"
    },
    {
        "id_tipo_logradouro": 75,
        "sigla": "EVD",
        "nome": "Elevada"
    },
    {
        "id_tipo_logradouro": 76,
        "sigla": "EX",
        "nome": "Eixo Industrial"
    },
    {
        "id_tipo_logradouro": 77,
        "sigla": "FAV",
        "nome": "Favela"
    },
    {
        "id_tipo_logradouro": 78,
        "sigla": "FAZ",
        "nome": "Fazenda"
    },
    {
        "id_tipo_logradouro": 79,
        "sigla": "FER",
        "nome": "Ferrovia"
    },
    {
        "id_tipo_logradouro": 80,
        "sigla": "FNT",
        "nome": "Fonte"
    },
    {
        "id_tipo_logradouro": 81,
        "sigla": "FRA",
        "nome": "Feira"
    },
    {
        "id_tipo_logradouro": 82,
        "sigla": "FTE",
        "nome": "Forte"
    },
    {
        "id_tipo_logradouro": 83,
        "sigla": "GAL",
        "nome": "Galeria"
    },
    {
        "id_tipo_logradouro": 84,
        "sigla": "GJA",
        "nome": "Granja"
    },
    {
        "id_tipo_logradouro": 85,
        "sigla": "HAB",
        "nome": "Núcleo Habitacional"
    },
    {
        "id_tipo_logradouro": 86,
        "sigla": "IA",
        "nome": "Ilha"
    },
    {
        "id_tipo_logradouro": 88,
        "sigla": "IOA",
        "nome": "Ilhota"
    },
    {
        "id_tipo_logradouro": 89,
        "sigla": "JD",
        "nome": "Jardim"
    },
    {
        "id_tipo_logradouro": 90,
        "sigla": "JDE",
        "nome": "Jardinete"
    },
    {
        "id_tipo_logradouro": 91,
        "sigla": "LD",
        "nome": "Ladeira"
    },
    {
        "id_tipo_logradouro": 92,
        "sigla": "LGA",
        "nome": "Lagoa"
    },
    {
        "id_tipo_logradouro": 93,
        "sigla": "LGO",
        "nome": "Lago"
    },
    {
        "id_tipo_logradouro": 94,
        "sigla": "LOT",
        "nome": "Loteamento"
    },
    {
        "id_tipo_logradouro": 95,
        "sigla": "LRG",
        "nome": "Largo"
    },
    {
        "id_tipo_logradouro": 96,
        "sigla": "LT",
        "nome": "Lote"
    },
    {
        "id_tipo_logradouro": 97,
        "sigla": "MER",
        "nome": "Mercado"
    },
    {
        "id_tipo_logradouro": 98,
        "sigla": "MNA",
        "nome": "Marina"
    },
    {
        "id_tipo_logradouro": 99,
        "sigla": "MOD",
        "nome": "Modulo"
    },
    {
        "id_tipo_logradouro": 100,
        "sigla": "MRG",
        "nome": "Projeção"
    },
    {
        "id_tipo_logradouro": 101,
        "sigla": "MRO",
        "nome": "Morro"
    },
    {
        "id_tipo_logradouro": 102,
        "sigla": "MTE",
        "nome": "Monte"
    },
    {
        "id_tipo_logradouro": 103,
        "sigla": "NUC",
        "nome": "Núcleo"
    },
    {
        "id_tipo_logradouro": 104,
        "sigla": "NUR",
        "nome": "Núcleo Rural"
    },
    {
        "id_tipo_logradouro": 105,
        "sigla": "OUT",
        "nome": "Outeiro"
    },
    {
        "id_tipo_logradouro": 106,
        "sigla": "PAR",
        "nome": "Paralela"
    },
    {
        "id_tipo_logradouro": 107,
        "sigla": "PAS",
        "nome": "Passeio"
    },
    {
        "id_tipo_logradouro": 108,
        "sigla": "PAT",
        "nome": "Pátio"
    },
    {
        "id_tipo_logradouro": 109,
        "sigla": "PC",
        "nome": "Praça"
    },
    {
        "id_tipo_logradouro": 110,
        "sigla": "PCE",
        "nome": "Praça de Esportes"
    },
    {
        "id_tipo_logradouro": 111,
        "sigla": "PDA",
        "nome": "Parada"
    },
    {
        "id_tipo_logradouro": 112,
        "sigla": "PDO",
        "nome": "Paradouro"
    },
    {
        "id_tipo_logradouro": 113,
        "sigla": "PNT",
        "nome": "Ponta"
    },
    {
        "id_tipo_logradouro": 114,
        "sigla": "PR",
        "nome": "Praia"
    },
    {
        "id_tipo_logradouro": 115,
        "sigla": "PRL",
        "nome": "Prolongamento"
    },
    {
        "id_tipo_logradouro": 116,
        "sigla": "PRM",
        "nome": "Parque Municipal"
    },
    {
        "id_tipo_logradouro": 117,
        "sigla": "PRQ",
        "nome": "Parque"
    },
    {
        "id_tipo_logradouro": 118,
        "sigla": "PRR",
        "nome": "Parque Residencial"
    },
    {
        "id_tipo_logradouro": 119,
        "sigla": "PSA",
        "nome": "Passarela"
    },
    {
        "id_tipo_logradouro": 120,
        "sigla": "PSG",
        "nome": "Passagem"
    },
    {
        "id_tipo_logradouro": 121,
        "sigla": "PSP",
        "nome": "Passagem de Pedestre"
    },
    {
        "id_tipo_logradouro": 122,
        "sigla": "PSS",
        "nome": "Passagem Subterrânea"
    },
    {
        "id_tipo_logradouro": 123,
        "sigla": "PTE",
        "nome": "Ponte"
    },
    {
        "id_tipo_logradouro": 124,
        "sigla": "PTO",
        "nome": "Porto"
    },
    {
        "id_tipo_logradouro": 125,
        "sigla": "Q",
        "nome": "Quadra"
    },
    {
        "id_tipo_logradouro": 126,
        "sigla": "QTA",
        "nome": "Quinta"
    },
    {
        "id_tipo_logradouro": 127,
        "sigla": "QTS",
        "nome": "Quintas"
    },
    {
        "id_tipo_logradouro": 128,
        "sigla": "R",
        "nome": "Rua"
    },
    {
        "id_tipo_logradouro": 129,
        "sigla": "R I",
        "nome": "Rua Integração"
    },
    {
        "id_tipo_logradouro": 130,
        "sigla": "R L",
        "nome": "Rua de Ligação"
    },
    {
        "id_tipo_logradouro": 131,
        "sigla": "R P",
        "nome": "Rua Particular"
    },
    {
        "id_tipo_logradouro": 132,
        "sigla": "R V",
        "nome": "Rua Velha"
    },
    {
        "id_tipo_logradouro": 133,
        "sigla": "RAM",
        "nome": "Ramal"
    },
    {
        "id_tipo_logradouro": 134,
        "sigla": "RCR",
        "nome": "Recreio"
    },
    {
        "id_tipo_logradouro": 135,
        "sigla": "REC",
        "nome": "Recanto"
    },
    {
        "id_tipo_logradouro": 136,
        "sigla": "RER",
        "nome": "Retiro"
    },
    {
        "id_tipo_logradouro": 137,
        "sigla": "RES",
        "nome": "Residencial"
    },
    {
        "id_tipo_logradouro": 138,
        "sigla": "RET",
        "nome": "Reta"
    },
    {
        "id_tipo_logradouro": 139,
        "sigla": "RLA",
        "nome": "Ruela"
    },
    {
        "id_tipo_logradouro": 140,
        "sigla": "RMP",
        "nome": "Rampa"
    },
    {
        "id_tipo_logradouro": 141,
        "sigla": "ROA",
        "nome": "Rodo Anel"
    },
    {
        "id_tipo_logradouro": 142,
        "sigla": "ROD",
        "nome": "Rodovia"
    },
    {
        "id_tipo_logradouro": 143,
        "sigla": "ROT",
        "nome": "Rotula"
    },
    {
        "id_tipo_logradouro": 144,
        "sigla": "RPE",
        "nome": "Rua de Pedestre"
    },
    {
        "id_tipo_logradouro": 145,
        "sigla": "RPR",
        "nome": "Margem"
    },
    {
        "id_tipo_logradouro": 146,
        "sigla": "RTN",
        "nome": "Retorno"
    },
    {
        "id_tipo_logradouro": 147,
        "sigla": "RTT",
        "nome": "Rotatória"
    },
    {
        "id_tipo_logradouro": 148,
        "sigla": "SEG",
        "nome": "Segunda Avenida"
    },
    {
        "id_tipo_logradouro": 149,
        "sigla": "SIT",
        "nome": "Sitio"
    },
    {
        "id_tipo_logradouro": 150,
        "sigla": "SRV",
        "nome": "Servidão"
    },
    {
        "id_tipo_logradouro": 151,
        "sigla": "ST",
        "nome": "Setor"
    },
    {
        "id_tipo_logradouro": 152,
        "sigla": "SUB",
        "nome": "Subida"
    },
    {
        "id_tipo_logradouro": 153,
        "sigla": "TCH",
        "nome": "Trincheira"
    },
    {
        "id_tipo_logradouro": 154,
        "sigla": "TER",
        "nome": "Terminal"
    },
    {
        "id_tipo_logradouro": 155,
        "sigla": "TR",
        "nome": "Trecho"
    },
    {
        "id_tipo_logradouro": 156,
        "sigla": "TRV",
        "nome": "Trevo"
    },
    {
        "id_tipo_logradouro": 157,
        "sigla": "TUN",
        "nome": "Túnel"
    },
    {
        "id_tipo_logradouro": 158,
        "sigla": "TV",
        "nome": "Travessa"
    },
    {
        "id_tipo_logradouro": 159,
        "sigla": "TVP",
        "nome": "Travessa Particular"
    },
    {
        "id_tipo_logradouro": 160,
        "sigla": "TVV",
        "nome": "Travessa Velha"
    },
    {
        "id_tipo_logradouro": 161,
        "sigla": "UNI",
        "nome": "Unidade"
    },
    {
        "id_tipo_logradouro": 162,
        "sigla": "V",
        "nome": "Via"
    },
    {
        "id_tipo_logradouro": 163,
        "sigla": "V C",
        "nome": "Via Coletora"
    },
    {
        "id_tipo_logradouro": 164,
        "sigla": "V L",
        "nome": "Via Local"
    },
    {
        "id_tipo_logradouro": 165,
        "sigla": "VAC",
        "nome": "Via de Acesso"
    },
    {
        "id_tipo_logradouro": 166,
        "sigla": "VAL",
        "nome": "Vala"
    },
    {
        "id_tipo_logradouro": 167,
        "sigla": "VCO",
        "nome": "Via Costeira"
    },
    {
        "id_tipo_logradouro": 168,
        "sigla": "VD",
        "nome": "Viaduto"
    },
    {
        "id_tipo_logradouro": 169,
        "sigla": "V-E",
        "nome": "Via Expressa"
    },
    {
        "id_tipo_logradouro": 170,
        "sigla": "VER",
        "nome": "Vereda"
    },
    {
        "id_tipo_logradouro": 171,
        "sigla": "VEV",
        "nome": "Via Elevado"
    },
    {
        "id_tipo_logradouro": 172,
        "sigla": "VL",
        "nome": "Vila"
    },
    {
        "id_tipo_logradouro": 173,
        "sigla": "VLA",
        "nome": "Viela"
    },
    {
        "id_tipo_logradouro": 174,
        "sigla": "VLE",
        "nome": "Vale"
    },
    {
        "id_tipo_logradouro": 175,
        "sigla": "VLT",
        "nome": "Via Litorânea"
    },
    {
        "id_tipo_logradouro": 176,
        "sigla": "VPE",
        "nome": "Via de Pedestre"
    },
    {
        "id_tipo_logradouro": 177,
        "sigla": "VRT",
        "nome": "Variante"
    },
    {
        "id_tipo_logradouro": 178,
        "sigla": "ZIG",
        "nome": "Zigue-Zague"
    }
];